const ETESTING_HOST_SUFFIX = ".solution-etesting.com"
const HTTPS_PREFIX = "https://"

function stripUriPathQueryFragment(hostPort: string): string {
  for (let i = 0; i < hostPort.length; i += 1) {
    const char = hostPort[i]
    if (char === "/" || char === "?" || char === "#" || char === "\\") {
      return hostPort.slice(0, i)
    }
  }
  return hostPort
}

/** Host part after https://, without path (no URL constructor — Vitest stubs global URL). */
function extractHttpsHostname(uri: string): string | null {
  if (!uri.toLowerCase().startsWith(HTTPS_PREFIX)) {
    return null
  }
  let hostPort = stripUriPathQueryFragment(uri.slice(HTTPS_PREFIX.length))
  if (hostPort === "" || hostPort.includes("@")) {
    return null
  }
  const colonIndex = hostPort.lastIndexOf(":")
  if (colonIndex !== -1) {
    hostPort = hostPort.slice(0, colonIndex)
  }
  return hostPort === "" ? null : hostPort.toLowerCase()
}

export function normalizeEtestingApiUri(raw: string): string {
  const trimmed = raw.trim()
  if (trimmed === "") {
    return ""
  }
  let uri = trimmed
  while (uri.endsWith("/")) {
    uri = uri.slice(0, -1)
  }
  if (uri.toLowerCase().startsWith("http://")) {
    uri = `${HTTPS_PREFIX}${uri.slice(7)}`
  }
  return uri
}

export function isValidEtestingTenantUrl(raw: string): boolean {
  const trimmed = raw.trim()
  if (trimmed === "") {
    return true
  }
  if (trimmed.toLowerCase().startsWith("http://")) {
    return false
  }
  const normalized = normalizeEtestingApiUri(raw)
  const host = extractHttpsHostname(normalized)
  if (host === null) {
    return false
  }
  return host.endsWith(ETESTING_HOST_SUFFIX) && host.length > ETESTING_HOST_SUFFIX.length
}
